/**
 * url纠错
 * @param url
 * @returns {string}
 */
function correctUrl(url) {
  url = _.trim(url);
  if (!url) return url;
  let isRouter = false;
  if (url.startsWith("/#")) {
    url = url.substring(2);
    isRouter = true;
  } else if (url.indexOf("#") === 0) {
    url = url.substring(1);
    isRouter = true;
  }
  //如果url非绝对路径且非:/表达式开头的就是相对路径或者路由，如果前缀没有/则补充/
  if (!dsf.url.isAbsolute(url) && !dsf.url.isExistColon(url) && url.indexOf("/") !== 0) {
    url = "/" + url;
  }
  if (isRouter) {
    url = "#" + url;
  }
  return url;
}

function findMenuByList(menuList, url) {
  url = correctUrl(url);
  for (let i = 0; i < menuList.length; i++) {
    let item = menuList[i];
    let menu = findMenu(item);
    if (menu && menu.menu_url && (window.__multiPageVm__ || menu.menu_opentype_value != 2)) {
      if (!url) return menu;
      else if (url == menu.menu_url) {
        return menu;
      }
    }
  }
  return null;
}

function findMenu(menu) {
  if (!menu) return null;
  let res = null;
  if (dsf.type(menu) == "array") res = findMenuByList(menu);
  else if (menu.menu_url) {
    if (!menu.children) {
      res = menu;
    } else {
      res = findMenuByList(menu.children, menu.menu_url) || menu;
    }
  } else if (menu.children) {
    res = findMenuByList(menu.children);
  } else {
    menu.menu_url = "#/404/_" + Date.now();
  }
  if (res) {
    res.menu_url = correctUrl(res.menu_url);
  }
  return res;
}

function url2Obj(menu, currentUrl) {
  if (!menu) return false;
  let obj = menu.__url_obj;
  if (obj) return obj;
  obj = null;
  let url = menu.param || menu.menu_url;
  if (!obj && url) {
    let isRouter = false;
    if (url.startsWith("/#")) {
      url = url.substring(2);
      isRouter = true;
    } else if (url.indexOf("#") === 0) {
      url = url.substring(1);
      isRouter = true;
    }
    let isAbsolute = dsf.url.isAbsolute(url);
    let isColon = dsf.url.isExistColon(url);
    let isExistExpress = dsf.url.isExistExpress(url);
    if (!isAbsolute && !isColon && url.indexOf("/") !== 0) {
      url = "/" + url;
    }
    if (isExistExpress) {
      url = dsf.url.getWebPath(url);
    }
    url = url.replace(/\?,/g, "%3F,").replace(/,\?/g, ",%3F");
    if (isRouter) {
      if (dsf.url.isHistoryRoute()) {
        currentUrl = currentUrl || dsf.url.parse(window.location.href);
        let base = dsf.url.getRouterBase();
        url = dsf.url.join(base, url);
      } else {
        currentUrl = currentUrl || dsf.url.parse(window.location.href);
        url = currentUrl.pathname + "#" + url;
      }
    }
    obj = menu.__url_obj = dsf.url.parse(url);
  } else return false;
  return obj;
}

/**
 * 判断不同路由页面是否会复用
 * @param menu
 * @returns {boolean}
 */
function isSamePage(menu) {
  let to = url2Obj(menu);
  if (!to) {
    return false;
  }
  let from = dsf.url.parse(location.href);
  return to.hashKey == from.hashKey;
}

/**
 * 打开菜单页（路由模式）
 */
function openPageByDefault(menu, isReplace) {
  let opentype = menu.menu_opentype_value;
  let isRouter = false;
  let url = menu.menu_url;
  if (url.indexOf("#") == 0 && url.indexOf("#/") != 0) {
    url = url.replace("#", "#/");
  }
  if (url.startsWith("#/")) {
    isRouter = true;
  }
  switch (opentype) {
  // 主窗口打开
  // case '1':
  //   if (isSamePage(menu)) {
  //     this.viewLoaded = false;
  //     this.$nextTick(() => {
  //       this.viewLoaded = true;
  //     });
  //   }
  //   isReplace ? window.top.location.replace(url) : (window.top.location.href = url);
  //   break;
  // 新窗口打开
  case "2":
    dsf.layer.openWindow(url);
    break;
    // 对话框打开
  case "3":
    dsf.layer.openDialog({
      title: menu.menu_name,
      width: "950px",
      height: "540px",
      params: {
        path: url
      }
    });
    break;
    // 当前窗口打开
  default:
    if (isSamePage(menu)) {
      this.viewLoaded = false;
      this.$nextTick(() => {
        this.viewLoaded = true;
      });
    }
    if (isRouter) {
      let urlInfo = dsf.url.parse(url);
      this.$router.push({ path: urlInfo.hashKey, query: urlInfo.hashQuery });
    } else {
      url = dsf.url.hashRouterToHistoryRouter(url);
      if (dsf.url.isExistExpress(url)) {
        url = dsf.url.getWebPath(url);
      }
      isReplace ? location.replace(url) : (location.href = url);
    }
  }
}

/**
 * 打开菜单页（单页面标签页模式）
 */
function openPageByMultiPageVm(menu) {
  let opentype = menu.menu_opentype_value;
  switch (opentype) {
  // 对话框打开
  case "3":
    dsf.layer.openDialog({
      title: menu.menu_name,
      width: "950px",
      height: "540px",
      params: {
        path: url
      }
    });
    break;
    // 当前窗口打开
  default:
    window.__multiPageVm__.$refs.main?.openTag(menu);
  }
}

/**
 * url2是否符合url1
 * 忽略下划线开头的参数
 * @param menu
 * @param currentUrl
 */
function urlsIsSame(menu, currentUrl) {
  let obj = url2Obj(menu, currentUrl);
  //history模式
  if (dsf.url.isHistoryRoute()) {
    if (!obj || obj.pathname !== currentUrl.pathname) {
      return false;
    }
    if (!obj || !dsf.isEqualObject(obj.searchQuery, currentUrl.searchQuery)) {
      return false;
    }
    let currentHashKeys = queryFilter(currentUrl.searchQuery).sort();
    let objHashKeys = queryFilter(obj.searchQuery).sort();
    if (currentHashKeys.length > objHashKeys.length) {
      return false;
    }
    for (let i = 0, l = objHashKeys.length; i < l; i++) {
      let k = objHashKeys[i];
      var rq = currentUrl.searchQuery[k];
      var iq = obj.searchQuery[k];
      if (!checkQuery(iq, rq)) {
        return false;
      }
    }
    for (let i = 0, l = currentHashKeys.length; i < l; i++) {
      let k = currentHashKeys[i];
      if (!obj.searchQuery[k]) {
        return false;
      }
    }
    return true;
  } else {
    if (!obj || obj.path !== currentUrl.path.split("?")[0]) {
      return false;
    }
    if (!obj || obj.hashKey !== currentUrl.hashKey) {
      return false;
    }
    let currentHashKeys = queryFilter(currentUrl.hashQuery).sort();
    let objHashKeys = queryFilter(obj.hashQuery).sort();
    if (currentHashKeys.length > objHashKeys.length) {
      return false;
    }
    for (let i = 0, l = objHashKeys.length; i < l; i++) {
      let k = objHashKeys[i];
      var rq = currentUrl.hashQuery[k];
      var iq = obj.hashQuery[k];
      if (!checkQuery(iq, rq)) {
        return false;
      }
    }
    for (let i = 0, l = currentHashKeys.length; i < l; i++) {
      let k = currentHashKeys[i];
      if (!obj.hashQuery[k]) {
        return false;
      }
    }
    return true;
  }
}

function queryFilter(obj) {
  let res = [];
  _.forEach(obj, (v, k) => {
    if (!/^_/.test(k)) {
      res.push(k);
    }
  });
  return res;
}

/**
 * 校验url参数
 *    1 匹配参数必须为1
 *    [*] 匹配参数非空任意值
 *    [1,a,c] 匹配参数为1、a、c中任意一个
 *    [?,*] 匹配参数可有可无
 *    [?,a,c] 匹配参数为a、c中任意一个,或者为空值
 * @param menuV
 * @param urlV
 */
function checkQuery(menuV, urlV) {
  if (!/^\[.+]$/.test(menuV)) {
    return urlV != void 0 && menuV == urlV;
  }
  let res = false;
  let arr = menuV.replace(/(^\[)|(]$)/g, "").split(",");
  for (let i = 0, l = arr.length; i < l; i++) {
    let v = arr[i];
    if (v === "?" && urlV == void 0) {
      res = true;
      break;
    }
    if (v === "*" && urlV != void 0) {
      res = true;
      break;
    }
    if (v == urlV) {
      res = true;
      break;
    }
  }
  return res;
}

export default {
  correctUrl,
  findMenu,
  urlsIsSame,
  openPage(menu, isReplace) {
    if (!menu) return;
    if (!menu.menu_url) {
      menu.menu_url = "";
    }
    if (window.__multiPageVm__) {
      openPageByMultiPageVm.call(this, menu);
    } else {
      openPageByDefault.call(this, menu, isReplace);
    }
  }
};
